module.exports = __webpack_public_path__ + "img/feature-tile-icon-03.0ea75190.svg";